import Image from './image-view'

export default Image
